// Hook: contagem de divergências pendentes (badge do item Header - E2, SPEC_DIVERGENCIAS_V2)
// Leitura: no mount, ao refocar a aba/janela, e via refetch() manual.
// Sem polling em intervalo - mesmo padrão de useSessaoISolve (R1).

import { useState, useEffect, useCallback } from 'react';
import { divergenciasApi } from '../services/api';

export function useDivergenciasPendentes() {
  const [pendentes, setPendentes] = useState<number | null>(null);

  const refetch = useCallback(async () => {
    try {
      const n = await divergenciasApi.contarPendentes();
      setPendentes(n);
    } catch {
      // Erro de rede/auth não quebra o app - badge fica no último estado
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  useEffect(() => {
    const handler = () => refetch();
    window.addEventListener('focus', handler);
    return () => window.removeEventListener('focus', handler);
  }, [refetch]);

  return { pendentes, refetch };
}
